import { useState } from 'react';
import { motion } from 'framer-motion';

export default function AdminNavbar({ darkMode, toggleDarkMode, activeTab, setActiveTab }) {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊' },
    { id: 'projects', label: 'Projects', icon: '🚀' },
    { id: 'analytics', label: 'Analytics', icon: '📈' },
    { id: 'messages', label: 'Messages', icon: '📧' },
    { id: 'settings', label: 'Settings', icon: '⚙️' }
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setIsOpen(false);
  };

  return (
    <>
      <motion.nav 
        className="navbar"
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5 }}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '1rem 2rem',
          background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.1), rgba(10, 10, 30, 0.15), rgba(0, 0, 0, 0.1))',
          backdropFilter: 'blur(30px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderBottom: '2px solid rgba(0, 255, 255, 0.3)'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '2rem' }}>
          <motion.div 
            className="nav-brand" 
            style={{ 
              fontSize: '1.5rem', 
              fontWeight: '900', 
              background: 'linear-gradient(45deg, #00ffff, #ff00ff)', 
              WebkitBackgroundClip: 'text', 
              WebkitTextFillColor: 'transparent', 
              textShadow: '0 0 10px rgba(0, 255, 255, 0.3)',
              cursor: 'pointer'
            }}
            whileHover={{ scale: 1.05 }}
            onClick={() => setActiveTab('dashboard')}
          >
            
          </motion.div>
          
          <motion.a
            href="/"
            whileHover={{ scale: 1.05, x: -5 }}
            style={{
              color: '#F25912',
              textDecoration: 'none',
              fontSize: '0.9rem',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.5rem 1rem',
              border: '1px solid rgba(255, 255, 0, 0.3)',
              borderRadius: '8px',
              background: 'rgba(255, 255, 0, 0.1)',
              textShadow: '0 0 5px rgba(255, 255, 0, 0.5)'
            }}
          >
            Portfolio
          </motion.a>
        </div>
        
        {/* Desktop Links */}
        <div className="nav-links-desktop" style={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
          {navItems.map((item) => (
            <motion.div
              key={item.id}
              onClick={() => handleTabClick(item.id)}
              whileHover={{ scale: 1.1, y: -2 }}
              whileTap={{ scale: 0.95 }}
              style={{ 
                color: activeTab === item.id ? '#00ffff' : 'var(--text-primary)', 
                cursor: 'pointer', 
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.5rem 1rem',
                borderRadius: '8px',
                background: activeTab === item.id ? 'rgba(0, 255, 255, 0.1)' : 'transparent',
                border: activeTab === item.id ? '1px solid rgba(0, 255, 255, 0.3)' : '1px solid transparent',
                transition: 'all 0.3s ease',
                fontWeight: activeTab === item.id ? 'bold' : 'normal',
                textShadow: activeTab === item.id ? '0 0 10px rgba(0, 255, 255, 0.5)' : 'none'
              }}
            >
              <span style={{ fontSize: '1.2rem' }}>{item.icon}</span>
              {item.label}
            </motion.div>
          ))}
        </div>

        <div className="nav-controls" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          {/* User Profile */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.8rem',
              padding: '0.5rem 1rem',
              background: 'rgba(255, 0, 255, 0.1)',
              border: '1px solid rgba(255, 0, 255, 0.3)',
              borderRadius: '25px',
              cursor: 'pointer'
            }}
          >
            <div style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              background: 'linear-gradient(45deg, #ff00ff, #00ffff)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1rem'
            }}>
              👨‍💻
            </div>
            <span style={{ color: '#ff00ff', fontWeight: 'bold', fontSize: '0.9rem' }}>
              Shankar
            </span>
          </motion.div>

          <div className="theme-toggle" onClick={toggleDarkMode}>
            <div className={`toggle-slider ${darkMode ? 'dark' : 'light'}`}>
              <span className="toggle-icon">{darkMode ? '⚡' : '💡'}</span>
            </div>
          </div>
          
          {/* Mobile Hamburger */}
          <button 
            className="mobile-menu-btn"
            onClick={() => setIsOpen(!isOpen)}
            style={{
              display: 'none'
            }}
          >
            <span style={{ width: '25px', height: '3px', background: 'linear-gradient(45deg, #00ffff, #ff00ff)', display: 'block', transition: 'all 0.3s', transform: isOpen ? 'rotate(45deg) translate(6px, 6px)' : 'none' }}></span>
            <span style={{ width: '25px', height: '3px', background: 'linear-gradient(45deg, #00ffff, #ff00ff)', display: 'block', transition: 'all 0.3s', opacity: isOpen ? 0 : 1 }}></span>
            <span style={{ width: '25px', height: '3px', background: 'linear-gradient(45deg, #00ffff, #ff00ff)', display: 'block', transition: 'all 0.3s', transform: isOpen ? 'rotate(-45deg) translate(6px, -6px)' : 'none' }}></span>
          </button>
        </div>
      </motion.nav>

      {/* Mobile Menu */}
      {isOpen && (
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mobile-menu"
          style={{
            position: 'fixed',
            top: '70px',
            left: 0,
            right: 0,
            background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.98), rgba(20, 20, 40, 0.98))',
            backdropFilter: 'blur(20px)',
            zIndex: 999,
            padding: '2rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
          }}
        >
          {navItems.map((item) => (
            <motion.div
              key={item.id}
              onClick={() => handleTabClick(item.id)}
              whileHover={{ scale: 1.02, x: 10 }}
              whileTap={{ scale: 0.98 }}
              style={{ 
                color: activeTab === item.id ? '#00ffff' : '#ffffff', 
                cursor: 'pointer', 
                textDecoration: 'none', 
                padding: '1rem', 
                textAlign: 'center', 
                border: activeTab === item.id ? '2px solid rgba(0, 255, 255, 0.5)' : '1px solid rgba(0, 255, 255, 0.2)', 
                borderRadius: '8px', 
                background: activeTab === item.id ? 'rgba(0, 255, 255, 0.1)' : 'rgba(0, 255, 255, 0.05)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.8rem',
                fontWeight: activeTab === item.id ? 'bold' : 'normal',
                fontSize: '1.1rem'
              }}
            >
              <span style={{ fontSize: '1.3rem' }}>{item.icon}</span>
              {item.label}
            </motion.div>
          ))}
        </motion.div>
      )}
    </>
  );
}